import React from "react";
import { Box, Typography, Stack, IconButton } from "@mui/material";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import globeImg from "../../Assets/EnquireySection/Globe.png";

const GlobalPresenceSection = () => {
  const offices = [
    {
      title: "Abilio realty Head Office (Hyderabad)",
      address:
        "#101A Images Capital Park, Silicon Valley, Madhapur Hyderabad - 500081",
    },
    {
      title: "Abilio realty (Bangalore)",
      address:
        "Abilio IT Solutions Pvt Ltd #CT13, Ramagondanahalli, Whitefield, 560067",
    },
    {
      title: "Abilio realty (United States)",
      address: "335 Ellenwood Dr, Middletown, Delaware - 19709",
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#F6F3F2",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: { xs: "64px 24px", md: "128px 64px" },
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1152px",
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: { xs: "64px", lg: "80px" },
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Left Side Content */}
        <Box
          sx={{
            width: { xs: "100%", lg: "536px" },
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            textAlign: "left",
          }}
        >
          <Box
            sx={{
              mb: "16px",
              maxWidth: "536px",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: 800,
                fontSize: { xs: "36px", md: "48px" },
                lineHeight: { xs: "44px", md: "56px" },
                color: "#1C1B1B",
                letterSpacing: "-1px",
                textAlign: "left",
              }}
            >
              Global presence.
              <br />
              Local expertise.
            </Typography>
          </Box>
          <Box
            sx={{
              maxWidth: "448px",
              mb: "40px",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter, sans-serif",
                fontWeight: 400,
                fontSize: "16px",
                lineHeight: "26px",
                color: "#57534E",
                textAlign: "left",
              }}
            >
              Our network spans the world's most prestigious postcodes. Locate
              our regional directors for on-the-ground insights.
            </Typography>
          </Box>

          <Stack spacing={2} sx={{ width: "100%", maxWidth: "536px" }}>
            {offices.map((office, idx) => (
              <Box
                key={idx}
                sx={{
                  width: "100%",
                  minHeight: "94px",
                  borderRadius: "10px",
                  border: "1px solid #E7E5E4",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  alignItems: "center",
                  padding: "24px 20px",
                  boxSizing: "border-box",
                  transition: "box-shadow 0.3s ease",
                  "&:hover": {
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
                  },
                }}
              >
                {/* Location Icon Box */}
                <Box
                  sx={{
                    width: "40px",
                    height: "44px",
                    borderRadius: "4px",
                    backgroundColor: "#FFDBD1",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexShrink: 0,
                    mr: "20px",
                  }}
                >
                  <LocationOnOutlinedIcon
                    sx={{ color: "#FF5722", fontSize: "20px" }}
                  />
                </Box>

                {/* Text Content */}
                <Box
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    pr: 2,
                    alignItems: "flex-start",
                    textAlign: "left",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 600,
                      fontSize: "15px",
                      color: "#1C1B1B",
                      lineHeight: "20px",
                      mb: "4px",
                      textAlign: "left",
                    }}
                  >
                    {office.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      fontSize: "13px",
                      color: "#57534E",
                      lineHeight: "18px",
                      textAlign: "left",
                    }}
                  >
                    {office.address}
                  </Typography>
                </Box>

                {/* Map Icon */}
                <IconButton sx={{ flexShrink: 0 }}>
                  <MapOutlinedIcon sx={{ color: "#57534E" }} />
                </IconButton>
              </Box>
            ))}
          </Stack>
        </Box>

        {/* Right Side Image Box */}
        <Box
          sx={{
            width: { xs: "100%", lg: "536px" },
            height: { xs: "auto", lg: "600px" },
            borderRadius: "16px",
            border: "8px solid #FFFFFF",
            backgroundColor: "#FFFFFF",
            boxShadow: "0px 20px 40px rgba(0, 0, 0, 0.05)",
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <Box
            component="img"
            src={globeImg}
            alt="Global Presence Globe"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              filter: "grayscale(100%)",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default GlobalPresenceSection;
